import { FormType } from 'src/components/pages/CoiFormManagement/types';

export const URL_FORM_TYPE_MAP = {
  'speak-up': FormType.SPEAK_UP,
  disclosure: FormType.CONFLICT_OF_INTEREST,
} as const;

export type FormTypeSlug = keyof typeof URL_FORM_TYPE_MAP;

const FORM_TYPE_TO_SLUG: Record<FormType, FormTypeSlug> = {
  [FormType.SPEAK_UP]: 'speak-up',
  [FormType.CONFLICT_OF_INTEREST]: 'disclosure',
};

export function getFormTypeFromUrl(
  urlParam: string | undefined,
): FormType | null {
  if (
    !urlParam ||
    !Object.prototype.hasOwnProperty.call(URL_FORM_TYPE_MAP, urlParam)
  ) {
    return null;
  }
  return URL_FORM_TYPE_MAP[urlParam as FormTypeSlug];
}

export function getSlugFromFormType(formType: FormType): FormTypeSlug {
  return FORM_TYPE_TO_SLUG[formType];
}
